import { restApiMP } from "@plannel/services/utils/rest-api";

// params: { versionId, resCd: [...], locCd: [...], periodStart: Date, periodEnd: Date }
// (Date는 restApiMP가 yyyy-MM-dd로 직렬화)
const getAll = (params) => {
  return restApiMP.get("/api/resource-gantt", { params });
};

const resourceGanttService = {
  getAll,
};

export default resourceGanttService;
